<template>
  <transition name="fade">
    <div v-if="showModal" class="note-modal">
      <div class="note-modal-backdrop" @click="closeModal"></div>

      <div class="note-modal-dialog">
        <div class="note-modal-content">
          <div class="note-modal-header">
            <h5 class="modal-title">Adicionar anotação para {{ requirementDesc }}</h5>
            <button type="button" class="close" @click="closeModal">
              <span>&times;</span>
            </button>
          </div>

          <div class="note-modal-body">
            <div class="note-text-container">
              <span>Digite sua anotação</span>
              <textarea class="form-control" rows="13" v-model="note"></textarea>
            </div>
          </div>

          <div class="note-modal-footer">
            <button class="cancel-button" @click="closeModal">
              <i class="fas fa-times"></i> Cancelar
            </button>

            <button class="send-button" @click="saveNote">
              <i class="fas fa-save"></i> Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['showModal', 'requirementInfo', 'closeAfter'],
  data() {
    return {
      requirementDesc: '',
      note: '',
    };
  },
  mounted() {
    if (Object.keys(this.requirementInfo).length) {
      if (this.requirementInfo.tipo_solicitacao) {
        this.requirementDesc = this.requirementInfo.tipo_solicitacao
      }
    }
  },
  methods: {
    closeModal(mode = 'default') {
      this.$emit('closeNoteModal', mode);
    },
    async saveNote() {
      if (!this.note) {
        Swal.fire({
          type: 'error',
          html: '<strong>Digite uma mensagem a ser adicionada como anotação!</strong>'
        });
        return
      }

      try {
        let loading;
        const { data } = await axios.post('insert-request-note', { id: this.requirementInfo.id, note: this.note })
        loading = Swal.fire({
          text: "Salvando anotação. Por favor, aguarde...",
          showConfirmButton: false,
          html: `<div><i class="fas fa-spinner fa-pulse"></i><br><span><b>Salvando anotação</b> <br>Por favor, aguarde...</span></div>`,
          allowOutsideClick: false
        });

        if (data && data?.status === 'success') {
          if (this.closeAfter && this.closeAfter == true) {
            loading.close();
            this.closeModal('saving');
          } else {
            Swal.fire({
              title: "Sucesso!",
              html: '<span>Sua anotação foi salva com sucesso!</span>',
              type: 'success',
              confirmButtonText: "Ok"
            }).then(() => {
              loading.close();
              this.closeModal('saving');
            });
          }
        } else if (!data || data?.status === 'error') {
          Swal.fire({
            title: "Erro!",
            html: '<span>Ocorreu um erro ao salvar a anotação</span>',
            type: 'error',
            confirmButtonText: "Ok"
          }).then(() => {
            loading.close()
            this.closeModal()
          });
        } else {
          Swal.fire({
            title: "Erro!",
            html: '<span>Ocorreu um erro ao salvar a anotação</span>',
            type: 'error',
            confirmButtonText: "Ok"
          }).then(() => {
            loading.close()
            this.closeModal()
          });
        }
      } catch (error) {
        console.error('Erro ao salvar anotação: ', error)
        loading.close()
        this.closeModal()
      }
    }
  },
};
</script>

<style scoped lang="scss">
.note-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.note-modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1040;
}

.note-modal-dialog {
  position: relative;
  z-index: 1051;
  background: white;
  border-radius: 0.3rem;
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  width: 70vw;
  height: 60vh;
  max-height: 60vh;
  max-width: 100%;
  overflow: hidden;
}

.note-modal-content {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.note-modal-header,
.note-modal-footer {
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
  font-weight: bold;
  display: flex;
  gap: 10px;

  button {
    border-radius: 7px !important;
    transition: 0.3s ease-in-out;
    border: none;
    padding: 5px 10px;
  }

  .send-button {
    background-color: rgb(46, 134, 46);
    color: white;

    &:hover {
      background-color: rgb(33, 95, 33);
    }
  }

  .cancel-button {
    background-color: rgb(179, 52, 52);
    color: white;

    &:hover {
      background-color: rgb(141, 42, 42);
    }
  }
}

.note-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .modal-title {
    font-weight: bold;
  }
}

.note-modal-body {
  padding: 1rem;
  display: flex;
  gap: 10px;
  max-height: 100%;
  overflow: hidden;
}

.note-text-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  border: 2px solid lightgray;
  border-radius: 7px;
  padding: 10px;
  background-color: white;
  box-shadow: 1px 1px 6px 0px lightgray;

  textarea {
    resize: none
  }

  span {
    font-size: medium;
    font-weight: bold;
  }

  .obs-span {
    font-size: x-small;
    margin: 3px;
    padding: 3px;
  }
}

.note-preview {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
  border: 2px solid lightgray;
  border-radius: 7px;
  padding: 10px;
  background-color: white;
  box-shadow: 1px 1px 6px 0px lightgray;
  min-width: 0;

  &__header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 20px;
    font-weight: bold;
    padding: 10px;

    button {
      border-radius: 10px !important;
    }
  }

  .preview-slot {
    background-image: url('/images/background-wpp.png');
    background-color: #263b47;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 100%;
    width: 100%;
    border-radius: 10px;
    overflow-y: auto;

    .message-item {
      background-color: #037963;
      color: white;
      border-radius: 10px;
      margin: 10px;
      padding: 10px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      .message-body {
        font-size: 12px;
        font-weight: 500;

        .body-preview-text {
          white-space: pre-line;
          word-wrap: break-word;
          overflow-wrap: break-word;
          word-break: break-word;
          width: 100%;
        }
      }
    }
  }
}

.note-modal-footer {
  display: flex;
  justify-content: flex-end;
}

.close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active em versões anteriores ao Vue 2.1.8 */
  {
  opacity: 0;
}
</style>